// Theme Action Types

export const CHANGE_THEME = 'CHANGE_THEME';